import request from '@/utils/request'

let Course_trial_appointmentApi = {

  /*试听预约列表*/
  list(data) {
    return request._post('/shop/plus.course_trial_appointment.Index/index', data);
},
/*添加试听预约*/
add(data) {
    return request._post('/shop/plus.course_trial_appointment.Index/add', data);
},
/*修改试听预约*/
edit(data) {
    return request._post('/shop/plus.course_trial_appointment.Index/edit', data);
},
/*删除试听预约*/
del(data) {
    return request._post('/shop/plus.course_trial_appointment.Index/del', data);
},
/*试听预约详情*/
detail(data) {
  return request._post('/shop/plus.course_trial_appointment.Index/detail', data);
},
    saveSetting(data, errorback) {
        return request._post('/shop/plus.course_trial_appointment.Setting/getSetting', data, errorback);
    },
    getSetting(data, errorback) {
        return request._get('/shop/plus.course_trial_appointment.Setting/getSetting', data, errorback);
    },
}
export default Course_trial_appointmentApi;



// WEBPACK FOOTER //
// ./src/api/course_trial_appointment.js